import type { ReactNode } from 'react'

export function StudioLayout({ children }: { children: ReactNode }) {
  return (
    <div className='flex h-full min-h-0 w-full overflow-hidden'>
      <div className='min-w-0 flex-1 overflow-auto'>{children}</div>
    </div>
  )
}
